var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSkyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8848_57395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8848_57395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 34.1315H25.7817V22H22.5187V34.1315ZM24.0002 18.4795C24.5185 18.4795 24.953 18.309 25.3037 17.968C25.6543 17.6266 25.8297 17.204 25.8297 16.7C25.8297 16.1586 25.6543 15.71 25.3037 15.354C24.9533 14.9983 24.5192 14.8205 24.0012 14.8205C23.4742 14.8205 23.0373 14.9983 22.6907 15.354C22.344 15.71 22.1707 16.1566 22.1707 16.694C22.1707 17.203 22.346 17.6278 22.6967 17.9685C23.0473 18.3091 23.4818 18.4795 24.0002 18.4795ZM24.0152 44.299C21.2085 44.299 18.5745 43.7676 16.1132 42.705C13.6518 41.6423 11.4992 40.189 9.65517 38.345C7.81117 36.501 6.35784 34.3476 5.29517 31.885C4.23251 29.4223 3.70117 26.7861 3.70117 23.9765C3.70117 21.1671 4.23251 18.5305 5.29517 16.0665C6.35784 13.6028 7.81051 11.4571 9.65317 9.62946C11.4958 7.80146 13.6488 6.35446 16.1122 5.28846C18.5755 4.22213 21.2123 3.68896 24.0227 3.68896C26.8327 3.68896 29.4702 4.2218 31.9352 5.28746C34.3998 6.35313 36.5457 7.7993 38.3727 9.62596C40.2 11.4526 41.6465 13.6006 42.7122 16.07C43.7782 18.5393 44.3112 21.1781 44.3112 23.9865C44.3112 26.7945 43.778 29.429 42.7117 31.89C41.6457 34.3513 40.1987 36.5005 38.3707 38.3375C36.543 40.1741 34.3952 41.627 31.9272 42.696C29.4592 43.7646 26.8218 44.299 24.0152 44.299Z",
    fill: "#33ACD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSkyBlue);
export default __webpack_public_path__ + "static/media/info_sky_blue.3925d143e2f1dfac5b430497bf3ba18e.svg";
export { ForwardRef as ReactComponent };